import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output
} from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { CollectorAvailabilityOverviewRow } from '../../domain/collector-availability-overview.model';
import { formatDuration, formatMinuteOfDay } from './availability-overview.utils';

@Component({
  selector: 'app-collector-availability-row',
  templateUrl: './collector-availability-row.component.html',
  styleUrls: ['./collector-availability-row.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CollectorAvailabilityRowComponent implements OnDestroy {
  @Input() row!: CollectorAvailabilityOverviewRow;
  @Input() selectedFromMinute = 0;
  @Input() selectedToMinute = 1440;
  @Input() clearPinnedTick = 0;
  @Output() pinnedChange = new EventEmitter<boolean>();

  copied = false;
  readonly formatDuration = formatDuration;
  readonly formatMinuteOfDay = formatMinuteOfDay;
  private copyTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(private clipboard: Clipboard) {}

  get availabilitySummary(): string {
    return this.row.availabilityState === 'missing'
      ? 'Not submitted'
      : `${this.formatDuration(this.row.freeMinutesInSelectedRange)} free`;
  }

  copyName(): void {
    if (this.clipboard.copy(this.row.name)) {
      this.copied = true;
      if (this.copyTimer) {
        clearTimeout(this.copyTimer);
      }
      this.copyTimer = setTimeout(() => {
        this.copied = false;
      }, 1600);
    }
  }

  onPinnedChange(value: boolean): void {
    this.pinnedChange.emit(value);
  }

  ngOnDestroy(): void {
    if (this.copyTimer) {
      clearTimeout(this.copyTimer);
    }
  }
}
